import { Box } from '@modusign/design-system';

export default function DocumentHeaderDivider() {
  return (
    <Box
      backgroundColor="#474747"
      display="inline-block"
      height="22px"
      marginY="auto"
      width="1px"
    />
  );
}
